// extracted by mini-css-extract-plugin
export default {"formWrapper":"ContactFormWithEmailSender_formWrapper__Sr9T1","box":"ContactFormWithEmailSender_box__Iw8LX"};